import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalComponent } from '../../global-component';
import { CurrentUser } from '../models/currentuser.models';
import { Observable } from 'rxjs';
import { TokenStorageService } from './token-storage.service';
import { TicketModel } from '../models/tickets.model';

const BASE_URL = GlobalComponent.BASE_API_URL;
@Injectable({ providedIn: 'root' })

/**
 * Tickets-service Component
 */
export class TicketsService {

  currentuser!: CurrentUser;

  constructor(private http: HttpClient, private tokenService: TokenStorageService) {
    this.currentuser = this.tokenService.getCurrentUser();
  }

  fetchTicketsStats(): Observable<any> {
    return this.http.get<any>(BASE_URL + 'ticket/ticketstats');
  }

  /* Support Ticket Rest Api
  */
  // Get
  getTicketData(limit: number, skip: number): Observable<TicketModel[]> {
    let currentuser = this.tokenService.getUser();
    let url = 'ticketsystems?filters[activestate][$eq]=true&filters[vendorguid]=' + this.tokenService.getVendorGUID()! + "&sort[0]=createdAt:DESC&pagination[page]="+skip+"&pagination[pageSize]="+limit;
    if (currentuser.usertype == 'client') {
      let userguid = currentuser.masterguid;
      if(currentuser.role && currentuser.role.type == 'super_admin') {
        userguid = currentuser.guid;
      }
      url = 'ticketsystems?filters[activestate][$eq]=true&filters[clientguid]=' + userguid + "&sort[0]=createdAt:DESC&pagination[page]="+skip+"&pagination[pageSize]="+limit;
    }

    return this.http.get<TicketModel[]>(BASE_URL + url);
  }

  // POST
  postTicketData(ticket: any): Observable<any> {
    return this.http.post(GlobalComponent.BASE_API_URL + 'ticketsystems', { data: ticket});
  }

  // Single
  getSingleTicketData(id: number): Observable<any> {
    return this.http.get(GlobalComponent.BASE_API_URL + 'ticketsystems/' + id + "?populate=attachments");
  }

   // UPDATE RECORD
   updateTicketData(ticket: any, recordid: number): Observable<any> {
    return this.http.put(GlobalComponent.BASE_API_URL + 'ticketsystems/' + recordid, { data: ticket});
  }

  // FETCH TICKET SYSTEM COMMENTS
  getTicketComments(ticketsystemguid: string): Observable<any> {
    return this.http.get(GlobalComponent.BASE_API_URL + 'ticketcomments?filters[ticketsystemguid]='+ticketsystemguid+"&filters[activestate]=true&sort[0]=createdAt:DESC&populate=attachments");
  }

  // POST
  postTicketCommentData(ticket: any): Observable<any> {
    return this.http.post(GlobalComponent.BASE_API_URL + 'ticketcomments', { data: ticket});
  }

}